import { Node } from "Models/node";

export const getNodes = (state: any): Node[] => state.nodes;
export const getActiveNodes = (state: any) =>
    getNodes(state).filter((n) => n.active);
export const getInactiveNodes = (state: any) =>
    getNodes(state).filter((n) => !n.active);
